export default {
  getHomeData: (state) => {
    return state.homeData;
  },
  getSuggestKeywords: (state) => {
    return state.suggestKeywords;
  },
};
